import React, { useState } from 'react'
import { columns, mobileColumns } from './Columns'
import ReactDataTable from '../../../../../../../components/_shared/Table/ReactDataTable'
import useWindowSize from '../../../../../../../../utils/hooks/useWindowSize'
import ReactExpandableTable from '../../../../../../../components/_shared/Table/ReactExpandableTable'
import ReportFooter from '../../ReportsFooter/ReportFooter'
const AppListReportsTable = ({
    isLoading,
    data,
    tableOptions,
    totaldata,
    pageCount,
    handleColumnSort,
    handlePageClick,
    handleRowsPerPage,
    downloadExcel,
    handleOnRowClicked,
     downloadPDF,
       reportCode,
}) => {
    const [currentRow, setCurrentRow] = useState(null)
    const size = useWindowSize()
    if (size.width < 768) {
        return (
            <>
                <h1 className="mb-4">App List Report</h1>
                <ReactExpandableTable
                    isLoading={isLoading}
                    data={data}
                    mobileColumns={mobileColumns}
                    pageCount={pageCount}
                    activePage={tableOptions?.activePage}
                    rowPerPages={tableOptions?.rowPerPages}
                    handleRowsPerPage={handleRowsPerPage}
                    removePagination={false}
                    handlePageClick={handlePageClick}
                    totaldata={totaldata}
                    setCurrentRow={setCurrentRow}
                    currentRow={currentRow}
                    handleOnRowClicked={handleOnRowClicked}
                    handleColumnSort={handleColumnSort}
                />
                <ReportFooter
                BackText={'Back'}
                PdfText="PDF"
                 MailText={'Mail'}
                ExcelText={'Excel'}
                onExcelClick={downloadExcel}
                onPdfClick={downloadPDF}
                  disableDataCheck={true}
                  reportTableData={data} // current page data
  isHeavyReport={true}
   reportCode={reportCode}
            />
            </>
        )
    }

    return (
        <>
            <h1 className="mb-4">App List Report</h1>
            <ReactDataTable
                isLoading={isLoading}
                data={data}
                columns={columns}
                pageCount={pageCount}
                activePage={tableOptions?.activePage}
                rowPerPages={tableOptions?.rowPerPages}
                totaldata={totaldata}
                handleRowsPerPage={handleRowsPerPage}
                removePagination={false}
                handlePageClick={handlePageClick}
                handleOnRowClicked={handleOnRowClicked}
                handleColumnSort={handleColumnSort}
            />
            <ReportFooter
                BackText={'Back'}
                PdfText="PDF"
                 MailText={'Mail'}
                ExcelText={'Excel'}
                onExcelClick={downloadExcel}
                onPdfClick={downloadPDF}
               reportTableData={data} // current page data
  isHeavyReport={true}
                  disableDataCheck={true}
                   reportCode={reportCode}
            />
        </>
    )
}

export default AppListReportsTable
